module.exports = __webpack_public_path__ + "img/66projekt-logo.29bf5abe.png";